import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "indexlayout-right-top-top" }
const _hoisted_2 = {
  key: 0,
  class: "indexlayout-top-menu"
}
const _hoisted_3 = { class: "indexlayout-top-menu-right" }
const _hoisted_4 = {
  key: 0,
  class: "indexlayout-right-top-bot"
}
const _hoisted_5 = { class: "indexlayout-right-top-bot-home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuUnfoldOutlined = _resolveComponent("MenuUnfoldOutlined")!
  const _component_MenuFoldOutlined = _resolveComponent("MenuFoldOutlined")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_bread_crumbs = _resolveComponent("bread-crumbs")!
  const _component_right_top_user = _resolveComponent("right-top-user")!
  const _component_EnvironmentOutlined = _resolveComponent("EnvironmentOutlined")!
  const _component_right_tab_nav = _resolveComponent("right-tab-nav")!

  return (_openBlock(), _createElementBlock("div", {
    id: "indexlayout-right-top",
    class: _normalizeClass({ topNavEnable: !_ctx.topNavEnable, tabNavEnable: !_ctx.tabNavEnable })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "indexlayout-flexible",
        onClick: _cache[0] || (_cache[0] = 
          () => {
            if (_ctx.toggleCollapsed) {
              _ctx.toggleCollapsed();
            }
          }
        )
      }, [
        (_ctx.collapsed)
          ? (_openBlock(), _createBlock(_component_MenuUnfoldOutlined, { key: 0 }))
          : (_openBlock(), _createBlock(_component_MenuFoldOutlined, { key: 1 }))
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              ref: "topMenuCon",
              style: _normalizeStyle({ width: _ctx.topMenuWidth })
            }, [
              (_ctx.topNavEnable)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.menuData, (item, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (!item.hidden)
                        ? (_openBlock(), _createBlock(_component_a_link, {
                            key: key,
                            to: item.path,
                            class: _normalizeClass([{ active: _ctx.belongTopMenu === item.path }, "indexlayout-top-menu-li"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t(item.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : (_openBlock(), _createBlock(_component_bread_crumbs, {
                    key: 1,
                    class: "breadcrumb",
                    list: _ctx.breadCrumbs
                  }, null, 8, ["list"]))
            ], 4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_right_top_user)
      ])
    ]),
    (_ctx.topNavEnable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_EnvironmentOutlined)
          ]),
          _createVNode(_component_bread_crumbs, {
            class: "breadcrumb",
            list: _ctx.breadCrumbs
          }, null, 8, ["list"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabNavEnable)
      ? (_openBlock(), _createBlock(_component_right_tab_nav, {
          key: 1,
          routeItem: _ctx.routeItem
        }, null, 8, ["routeItem"]))
      : _createCommentVNode("", true)
  ], 2))
}